import monoApi from "@/core/services/monoapi.service"

// action types
export const GET_SIZES = "getSizes";

// mutation types
export const REQUEST_SIZES = 'REQUEST_SIZES'
export const REQUEST_SIZES_SUCCESS = 'REQUEST_SIZES_SUCCESS'
export const REQUEST_SIZES_ERROR = 'REQUEST_SIZES_ERROR'

export default {
    state: {
        isFetching: false,
        error: null,
        item: {},
        items:[],
        validation: {}
    },
    getters: {
        /**
         * Get list of breadcrumbs for current page
         * @param state
         * @returns {*}
         */
        
    },
    actions: {
        /**
         * Set the breadcrumbs list
         * @param state
         * @param payload
         */
        [GET_SIZES] ({ commit } ) {      
            commit(REQUEST_SIZES)
            return monoApi.get(`/sizes`)
                .then(res => {
                    commit(REQUEST_SIZES_SUCCESS, {
                        payload: res.data
                    })
                })
                .catch(error => {
                    commit(REQUEST_SIZES_ERROR, { error })
                })
        },  
    },
    mutations: {
        [REQUEST_SIZES] (state) {
            state.isFetching = true
            state.error = null
        },
    
        [REQUEST_SIZES_SUCCESS] (state, action) {
        state.isFetching = false
        state.items = [...action.payload]    
        state.error = null
        },
    
        [REQUEST_SIZES_ERROR] (state, action) {
        state.isFetching = false
        state.error = action.error
        }
    }        
}
